<!-- US 6920: Signatures are read-only here; changes go through a new Global Workflow version approved by another Super Admin -->
<div class="d-flex align-items-center justify-content-between pt-2 small">
  <span>
    <mat-icon class="yellow align-middle">lock</mat-icon>
    Signatures are read-only here. To change them, create a new SCF version in
    Global Workflows; another Super Admin must approve it before it takes effect.
  </span>
  <a mat-stroked-button color="primary" routerLink="/workflow" target="_blank">
    Open Global Workflows
  </a>
</div>
<div class="d-flex flex-column justify-content-between pt-2 settings-container">
  <div class="card mb-2" *ngFor="let section of sections">
    <div class="card-header">
      {{ section.name }}
    </div>
    <div class="card-body">
      <fieldset class="field-group" *ngFor="let step of getSteps(section.id)">
        <legend>{{ step.name }}</legend>
        <div
          class="d-flex flex-row justify-content-around flex-wrap drop-list"
        >
          <div
            *ngFor="let task of getTasks(step)"
            class="my-1 mx-2"
            [ngStyle]="{
              width: section.id == 4 ? '100%' : calcWidth(step)
            }"
          >
            <span class="relative">
              <master-control
                [builder]="true"
                [type]="task.type"
                [visible]="true"
                [disabled]="false"
                [color]="'primary'"
                number=""
                [header]="task.name"
                [question]="task.type == 3 ? task.name2 : task.name"
                [questionDisabled]="true"
                [label]="task.name"
                [text]="task.name2"
                [radioQuestion]="task.name3"
                [checkbox_checked]="false"
                [showApprove]="getAction(1, task)"
                [showDisapprove]="getAction(2, task)"
                [showUnapprove]="getAction(3, task)"
                [roleIds]="getRoleIds(task)"
                [roleCodes]="getRoleCodes(task)"
                [textBefore]="task.name"
                [textAfter]="task.name2"
                [textAfter2]="task.name3"
                [checkboxVisible]="true"
                [disableEdit]="true"
                [moreInfo]=""
                [configuration]="task.configuration"
                [formType]="1"
                [formId]="0"
                [taskId]="0"
                style="width: 100%"
                [RolesToApproveChanges]="['RWAPI']"
                [tooltips]="getTooltips(task)"
              >
              </master-control>
            </span>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</div>
